import { render, staticRenderFns } from "./ImportShipment.vue?vue&type=template&id=74097f88&scoped=true&"
import script from "./ImportShipment.vue?vue&type=script&lang=js&"
export * from "./ImportShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74097f88",
  null
  
)

export default component.exports